// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

// Turbo disables form elements during submission, moving keyboard focus away.
// Capture the active element before Turbo's submit handler runs, then restore it.
let savedFocusTarget = null

document.addEventListener("submit", () => {
  const el = document.activeElement
  if (el && el !== document.body && el !== document.documentElement) {
    savedFocusTarget = el.id || el.name || null
  }
}, { capture: true, passive: true })

document.addEventListener("turbo:submit-end", () => {
  if (!savedFocusTarget) return
  const target = savedFocusTarget
  savedFocusTarget = null
  const el = document.getElementById(target) || document.querySelector(`[name="${target}"]`)
  if (el) el.focus()
})
